export default {
  hr: [',', '.'],
  default: [',', '.']
};
